module.exports = __webpack_public_path__ + "img/partner 15.958a9ee0.jpg";